/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ThgCreateUserDtoGen,
  ThgExceptionViewmodelGen,
  ThgPageViewModelGen,
  ThgPartnerUserControllerFindAllByPartnerIdParamsGen,
  ThgPartnerUserPermissionDtoGen,
  ThgPartnerUserViewModelGen,
  ThgUpdatePartnerUserDtoGen,
  ThgUploadUserAvatarDtoGen,
  ThgUserIdentityViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class PartnerUser<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerCreate
   * @summary Create a user
   * @request POST:/partner/{partnerId}/user
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The created user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `409` `ThgExceptionViewmodelGen` A user with this email already exists
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerCreate = (partnerId: string, data: ThgCreateUserDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerFindAllByPartnerId
   * @summary Get all users for a partner
   * @request GET:/partner/{partnerId}/user
   * @secure
   * @response `200` `(ThgPageViewModelGen & { data?: (ThgPartnerUserViewModelGen)[] })`
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerFindAllByPartnerId = (
    { partnerId, ...query }: ThgPartnerUserControllerFindAllByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPageViewModelGen & { data?: ThgPartnerUserViewModelGen[] }, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerInvite
   * @summary (CREATE - USER) Creates an new user and send invitation email to new user.
   * @request POST:/partner/{partnerId}/user/invite
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The invited user with read permissions
   * @response `400` `void` Bad request.
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `void` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerInvite = (partnerId: string, data: ThgCreateUserDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgPartnerUserViewModelGen, void | ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/invite`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerFindOneByPartnerId
   * @summary Get a user by id
   * @request GET:/partner/{partnerId}/user/{id}
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The found user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerFindOneByPartnerId = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerUpdate
   * @summary Update a user by id
   * @request PATCH:/partner/{partnerId}/user/{id}
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The updated user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerUpdate = (
    partnerId: string,
    id: string,
    data: ThgUpdatePartnerUserDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerRemove
   * @summary Deletes a user for a given partner
   * @request DELETE:/partner/{partnerId}/user/{id}
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` User deleted
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerRemove = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerFindOneByNameAndPartnerId
   * @summary Get a user by username
   * @request GET:/partner/{partnerId}/user/{username}/byName
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The found user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerFindOneByNameAndPartnerId = (partnerId: string, username: string, params: RequestParams = {}) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${username}/byName`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerGetUserStatusByPartnerId
   * @summary Get a user by id
   * @request GET:/partner/{partnerId}/user/{id}/status
   * @secure
   * @response `200` `ThgUserIdentityViewModelGen` The found user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerGetUserStatusByPartnerId = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<ThgUserIdentityViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerUploadAvatar
   * @summary Uploads the profile picture of a user of the partner, jpg or png, max 2 mb
   * @request POST:/partner/{partnerId}/user/{id}/avatar
   * @secure
   * @response `201` `ThgPartnerUserViewModelGen` The updated user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `409` `ThgExceptionViewmodelGen` The profile picture was changed by another request
   * @response `413` `ThgExceptionViewmodelGen` Payload too large
   * @response `415` `ThgExceptionViewmodelGen` Unsupported Media Type
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerUploadAvatar = (
    partnerId: string,
    id: string,
    data: ThgUploadUserAvatarDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}/avatar`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerRemoveAvatar
   * @summary Removes the profile picture of a user of the partner
   * @request DELETE:/partner/{partnerId}/user/{id}/avatar
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The updated user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `409` `ThgExceptionViewmodelGen` The profile picture was changed by another request
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerRemoveAvatar = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}/avatar`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * @description <p>This endpoint can be used in the admin sign up flow</p> <ol> <li>Partner invites a User</li> <li>User lost invitation mail or temporary password is exceeded (Status is still FORCE_CHANGE_PASSWORD)</li> <li>Use this endpoint to resend invitation mail for a user from the user pool</li> </ol> <p>Summary: Resend invitation for an invited user in case the user lost the initial mail. Is only working is the user status is FORCE_CHANGE_PASSWORD</p>
   *
   * @tags PartnerUser
   * @name PartnerUserControllerResendInvitation
   * @summary Resend invitation for an invited user in case the user lost the initial mail. Is only working if the user status is FORCE_CHANGE_PASSWORD
   * @request POST:/partner/{partnerId}/user/{id}/resendInvitationMessage
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The reinvited user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerResendInvitation = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}/resendInvitationMessage`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerAddPermission
   * @summary Add a permission to a user by id
   * @request PATCH:/partner/{partnerId}/user/{id}/permission/add
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The updated record
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerAddPermission = (
    partnerId: string,
    id: string,
    data: ThgPartnerUserPermissionDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}/permission/add`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerUser
   * @name PartnerUserControllerRemovePermission
   * @summary Removes a permission for a user by id
   * @request PATCH:/partner/{partnerId}/user/{id}/permission/remove
   * @secure
   * @response `200` `ThgPartnerUserViewModelGen` The updated record
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `404` `ThgExceptionViewmodelGen` Not Found
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerUserControllerRemovePermission = (
    partnerId: string,
    id: string,
    data: ThgPartnerUserPermissionDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPartnerUserViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/user/${id}/permission/remove`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
